let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("8j330")).then(() => parcelRequire('kn9Jn'));